import { castArray, compact, uniqBy } from 'lodash-es'
import { GROUP_TYPE_SYSTEM, PRACTITIONER_ROLE } from '#src/codeSystems.ts'
import type { Merger } from '#src/merge/mergers/merger.ts'

const MULTI_VALUED_SYSTEMS = new Set([PRACTITIONER_ROLE, GROUP_TYPE_SYSTEM])

export const practitionerRoleIdentifierMerger: Merger = {
  canMerge: ({ current, incoming, key }) =>
    key === 'identifier' && (Array.isArray(current) || Array.isArray(incoming)),
  merge: ({ current, incoming }) => {
    const currentIdentifiers = castArray(current)
    const incomingIdentifiers = castArray(incoming)

    const mergedIdentifiers = uniqBy(
      compact([...incomingIdentifiers, ...currentIdentifiers]),
      (v) => {
        if (MULTI_VALUED_SYSTEMS.has(v.system)) {
          return `${v.system}|${v.value ?? ''}`
        }
        return v.system
      }
    )

    return mergedIdentifiers
  },
}
